import React, {useEffect, useState} from "react";
import {Form, Row, Col, Input, InputNumber, Select, Space, Button, DatePicker, Grid, Breakpoint, Checkbox} from "antd";
import {ColumnGroupType, ColumnType as AntColumnType} from "antd/lib/table/interface";
import {FormInstance} from "antd/lib/form";

import styles from "./searchBar.module.css";

const useBreakpoint = Grid.useBreakpoint;



enum SearchValueType {
    text = 'text',
    select = 'select',
    date = 'date',
    time = 'time',
    dateRange = 'dateRange',
    timeRange = 'timeRange',
    dateTimeRange = 'dateTimeRange',
    digit = 'digit',
    check = 'check',
}

type SearchValueEnum = {
    text: string,
    value: any,
}[]
type SearchColSize = 'large' | 'middle' | 'small';
type FormRenderFunction = (form: FormInstance) => JSX.Element;
type SearchOptionConfig = {
    valueType?: (SearchValueType | string);
    valueInitial?: any;
    valueEnum?: SearchValueEnum;
    valueRender?: JSX.Element | FormRenderFunction;
    size?: SearchColSize;
    colSpan?: number;
};

interface SearchColumnType {
    search?: boolean | SearchOptionConfig;
}

export type ColumnType = ((ColumnGroupType<unknown> | AntColumnType<unknown>) & SearchColumnType & { dataIndex: string });

type ColumnTypeSpecific = ColumnType & {
    search: Exclude<SearchOptionConfig, 'size' | 'colSpan'> & { size: SearchColSize } & { colSpan: number };
    dataIndex: string
};

interface SearchBarProps {
    columns: Array<ColumnType>
    form: FormInstance
    onSubmit: () => void
    onReset: () => void
}

function SearchBar(props: SearchBarProps) {
    const [isCollapse, setCollapse] = useState(true);
    const {form, onSubmit, onReset} = props;
    const columns = props.columns.map(col => {
        const colInitialized: ColumnType = (typeof col.search != "object") ? {
            ...col,
            search: {size: 'small', colSpan: 0}
        } : col;
        (colInitialized.search as SearchOptionConfig).size = (colInitialized.search as SearchOptionConfig).size ?? 'small';
        (colInitialized.search as SearchOptionConfig).colSpan = (colInitialized.search as SearchOptionConfig).colSpan ?? 0;
        return colInitialized as ColumnTypeSpecific;
    });
    const screens = useBreakpoint();
    useEffect(() => {
        getCurScreenBreakPoint();


        // if (screens.xxl) {
        //     setColsInRow(4)
        // } else if (screens.xl) {
        //     setColsInRow(3)
        // } else if (screens.lg) {
        //     setColsInRow(2)
        // } else {
        //     setColsInRow(1)
        // }

    }, [screens]);

    function getSpanProps(col?: ColumnType) {
        if (!col) {
            return {xxl: 6, xl: 8, lg: 8, md: 12, sm: 12, xs: 12};
        }
        const column = col as ColumnTypeSpecific;
        column.search.colSpan = column.search.colSpan ?? 0;
        column.search.size = column.search.size || 'small';
        if (column.search.colSpan) {
            return {span: column.search.colSpan};
        }
        switch (column.search.size) {
            case "large":
                return {xxl: 18, xl: 12, lg: 24, md: 24, sm: 24, xs: 24};
            case "middle":
                return {xxl: 12, xl: 8, lg: 8, md: 24, sm: 24, xs: 24};
            case "small":
                return {xxl: 6, xl: 8, lg: 8, md: 12, sm: 12, xs: 12};
        }
        return {xxl: 6, xl: 8, lg: 8, md: 12, sm: 12, xs: 12};
    }

    function getCurScreenBreakPoint() {
        const screenBreakPoints: Array<Breakpoint> = ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'];
        const curScreen = screenBreakPoints.reverse().find(s => screens[s]);
        return curScreen ?? 'sm';
    }

    function onFormRest() {
        if (onReset) onReset();
        //onSubmit()
    }

    function onFormSubmit() {
        if (onSubmit) onSubmit();
    }

    function renderItem(item: ColumnType) {
        const searchConfig = (item.search || {}) as SearchOptionConfig;
        const {valueType = SearchValueType.text, valueEnum = [], valueRender} = searchConfig;
        if (valueRender) {
            if(typeof valueRender === "function"){
                return valueRender(form);
            }
            if (valueRender.type === React.Fragment) {
                return valueRender.props.children;
            }
            return valueRender;
        }
        if (valueType === SearchValueType.text) {
            return (
                <Input/>
            )
        } else if (valueType === SearchValueType.digit) {
            return (
                <InputNumber/>
            )
        } else if (valueType === SearchValueType.dateRange) {
            return (
                <DatePicker.RangePicker allowClear={false}/>
            )
        } else if (valueType === SearchValueType.select) {
            return (
                <Select allowClear>
                    {valueEnum.map(item => (
                        <Select.Option key={item.value} value={item.value}>{item.text}</Select.Option>
                    ))}
                </Select>
            )
        } else if (valueType===SearchValueType.check){
            return (
                <Checkbox/>
            )
        }
    }

    function renderOperateElement() {
        return (
            <Space>
                <Button onClick={onFormRest}>重置</Button>
                <Button onClick={onFormSubmit} type={"primary"} htmlType={'submit'}>搜索</Button>
                <a onClick={() => setCollapse(!isCollapse)}>{isCollapse ? '展开' : '收起'}</a>
            </Space>
        )
    }

    /*function renderColumns() {
        const singleColSpan = 24 / colsInRow
        const operateElement = renderOperateElement();
        const total = columns.length;
        const groupColumns: Array<Array<ColumnType | any>> = new Array(Math.ceil((total + 1) / colsInRow)).fill(new Array()).map(arr => [...arr]);
        const operateElementPush = singleColSpan * (colsInRow - 1 - (isCollapse ? Math.min(colsInRow - 1, total) : total) % colsInRow);
        for (let i = 0; i <= total; i++) {
            const rowIndex = Math.floor(i / colsInRow);
            const needHidden = isCollapse && (i + 1 + 1) > colsInRow;
            const column = columns[i];
            const searchConfig = (column?.search || {}) as SearchOptionConfig;
            const rowClassName = 'SearchBar-Col' + (rowIndex + 1 === groupColumns.length || (isCollapse && rowIndex === 0) ? ' LastRow' : '')
            const item = i === total || (<Form.Item key={column.dataIndex} hidden={needHidden} name={column.dataIndex}
                                                    label={column.title?.toString()}
                                                    initialValue={(searchConfig.valueInitial != null && true) ? searchConfig.valueInitial : null}>{renderItem(column)}</Form.Item>)
            i !== total ?
                groupColumns[rowIndex].push(needHidden ? item : (
                    <Col className={rowClassName} key={column.dataIndex} span={singleColSpan}>{item}</Col>))
                :
                groupColumns[isCollapse ? 0 : rowIndex].push(<Col key={'op'} span={singleColSpan}
                                                                  style={{textAlign: 'right'}}
                                                                  push={operateElementPush}>{operateElement}</Col>);
        }
        return groupColumns.map((g, index) => (
            <Row key={index} gutter={{xs: 8, sm: 16, md: 24}}>{g}</Row>
        ))
    }*/

    function renderColumnsV2() {
        const operateElement = renderOperateElement();
        let collapsedColumns = [...columns];
        if (isCollapse) {
            const curScreenBreakPoint: Breakpoint = getCurScreenBreakPoint();
            const operateElementColSpan: { [key in Breakpoint]?: number } = getSpanProps();
            let canDisplaySpan = 24 - (operateElementColSpan[curScreenBreakPoint] ?? 0);
            collapsedColumns = [...columns].filter((col, index) => {
                const colSpan = getSpanProps(col)[col.search.colSpan ? 'span' : curScreenBreakPoint] ?? 0;
                if (colSpan <= canDisplaySpan) {
                    canDisplaySpan -= colSpan;
                    return true;
                }
                canDisplaySpan = 0;
                return false;
            })
        }
        return (
            <div>
                <Row align={'top'} wrap gutter={{xs: 8, sm: 16, md: 24}} style={{textAlign: 'end'}}>
                    {
                        collapsedColumns.map(col => {
                            const searchConfig = (col.search || {}) as SearchOptionConfig;
                            return (
                                <Col {...getSpanProps(col)} style={{textAlign: col.title?'end':'start'}}>
                                    <Form.Item
                                        key={col.dataIndex}
                                        name={col.dataIndex}
                                        label={col.title?.toString()}
                                        labelCol={col.title?{span:8}: {span:0}}
                                        style={{textAlign: "start"}}
                                        wrapperCol={col.title?{span:16}:{span:24}}
                                        initialValue={(searchConfig.valueInitial != null && true) ? searchConfig.valueInitial : null}
                                        valuePropName={searchConfig.valueType==='check'?'checked':undefined}>
                                        {renderItem(col)}
                                    </Form.Item>
                                </Col>
                            )
                        })
                    }
                    {
                        <Col key={'op'} {...getSpanProps()} style={{flexGrow: 1, maxWidth: '100%'}}>
                            {operateElement}
                        </Col>
                    }
                </Row>
            </div>
        )
    }

    return (
        <div className={styles.searchBarContainer}>
            <Form form={form} labelCol={{span: 8}} wrapperCol={{span: 16}}>
                {renderColumnsV2()}
            </Form>
        </div>
    )
}

export default SearchBar
